<fgb-page-header
  [pageTitle]="'games.page.trivia'"
  [backButtonLink]="'/games'"
  [showFooter]="false"
  [showBanner]="false"
></fgb-page-header>
<!--Banner-->
<fgb-portal-games-banner [isTriviaPage]="true"></fgb-portal-games-banner>
<!--Nav-->
<div class="mb-3">
  <router-outlet></router-outlet>
</div>
